import styled from "styled-components";

import { THEMES } from "../../../constants";

import type { LabAssetType } from "../labAssets.types";
import { LAB_ASSET_TYPE_LABELS } from "../labAssets.utils";

// Same shape as ValidationDueBadge so the two sit together in the table;
// blue/purple to stay clear of its red/orange.
const Badge = styled.span<{ $assetType: LabAssetType }>`
  display: inline-block;
  padding: 2px 4px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
  background-color: ${({ $assetType, theme }) =>
    theme.name === THEMES.DARK
      ? $assetType === "software"
        ? "rgba(107, 33, 168, 0.2)"
        : "rgba(26, 86, 219, 0.2)"
      : $assetType === "software"
      ? "#F3E8FF"
      : "#E8F0FE"};
  color: ${({ $assetType, theme }) =>
    theme.name === THEMES.DARK
      ? $assetType === "software"
        ? "#C4A6F2"
        : "#8AB4F8"
      : $assetType === "software"
      ? "#6B21A8"
      : "#1A56DB"};
  border: 1px solid
    ${({ $assetType, theme }) =>
      theme.name === THEMES.DARK
        ? $assetType === "software"
          ? "rgba(107, 33, 168, 0.3)"
          : "rgba(26, 86, 219, 0.3)"
        : $assetType === "software"
        ? "rgba(107, 33, 168, 0.2)"
        : "rgba(26, 86, 219, 0.2)"};
`;

/** Color-coded Hardware/Software badge (ENG-2292). Renders nothing for no type. */
export const AssetTypeBadge = ({
  type,
  className,
}: {
  type?: LabAssetType | null;
  className?: string;
}) =>
  type ? (
    <Badge
      $assetType={type}
      className={className}
      data-testid="asset-type-badge"
      data-type={type}
    >
      {LAB_ASSET_TYPE_LABELS[type] ?? type}
    </Badge>
  ) : null;
